import { ApiResponse, TokenData, LeadNewness } from '../models';
import * as http from './http';
import ApiService from './service';

export class LeadNewnessService extends ApiService {
  public async loadAllLeadNewness() {
    const url = `${this.apiDomain}/api/lead-newness`;

    const resposne = await http.get<ApiResponse<LeadNewness[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async updateLeadNewness(data: LeadNewness, id?: string) {
    const url = `${this.apiDomain}/api/lead-newness/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
}
